import { Injectable, inject } from '@angular/core';
import {  CrudQuery, CrudService } from '@shared/modules/crud/crud.service';
import {  MODELNAME } from './consorcios.config';
import { Question, SUBCOLLECTION, TypeQuestion } from './questions.config';
import { Observable } from 'rxjs';
import { Timestamp } from '@angular/fire/firestore';



@Injectable({
    providedIn: 'root',
})
export class QuestionsService {
    model = MODELNAME;
    crudService = inject(CrudService);
    subcollection = SUBCOLLECTION;

    getAllByUser(id: string): Observable<Question[]> {
           const path = this.subcollection;
           this.crudService.setModel(path);
           const query: CrudQuery = {
                   field: 'administrationUserId',
                   operator: '==',
                   value: id,
                   orderBy: 'createdAt',
                   orderByDirection: 'desc',
               };
               return this.crudService.searchCollectionGroup<Question>(query);
       }
       
   

    create(consorcioId: string, data: any) {
        const path = this.model + '/' + consorcioId + '/' + this.subcollection;
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }

    update(consorcioId: string, id: string, data: any) {
        const path =
            this.model +
            '/' +
            consorcioId +
            '/' +
            this.subcollection +
            '/' +
            id;
        this.crudService.setModel(path);
        return this.crudService.update('', data);
    }

      async countByStatusAndDate(filters:{adminId: string,dateFrom?: any,closedFrom?: any,closedBy?: 'agent' | 'human', status?:string[],type?: TypeQuestion,notType?: TypeQuestion}): Promise<number> {
            const path =this.subcollection;
            this.crudService.setModel(path);
    
            const query: any[] = [
               {field: 'administrationUserId',
                 operator: '==',
                 value: filters.adminId
                }
            ];
    
            if(filters.dateFrom){
               const dateFromTs = Timestamp.fromDate(filters.dateFrom);
                query.push({
                    field: 'createdAt',
                    operator: '>=',
                    value: dateFromTs,
                });
            }
    
            if(filters.closedFrom){
                  const closedFromTs =Timestamp.fromDate(filters.closedFrom);
                query.push({
                    field: 'closedAt',
                    operator: '>=',
                    value: closedFromTs,
                });
            }
    
            if(filters.status){
                query.push({
                    field: 'status',
                    operator: 'in',
                    value: filters.status,
                });
            }
            
            if(filters.type){
                query.push({
                    field: 'type',
                    operator: '==',
                    value: filters.type,
                });
            }
            
            if(filters.notType){
                query.push({
                    field: 'type',
                    operator: '!=',
                    value: filters.notType,
                });
            }
            
            if(filters.closedBy){
                query.push({
                    field: 'closedBy',
                    operator: '==',
                    value: filters.closedBy,
                });
            }
    
            
            const total = await this.crudService.findWhereGroupCount(query, [{
                orderBy: 'createdAt',
                orderByDirection: 'desc',
            },
            {
                orderBy: 'status',
                orderByDirection: 'asc',
            }
        ]);
            return total;
        }

    getAllByConsorcio(consorcioId: string) {
        this.crudService.setModel(
            this.model + '/' + consorcioId + '/' + this.subcollection
        );
        return this.crudService.findAll<any>();
    }

    getSubObjectById(consorcioId: string, id: string) {
        this.crudService.setModel(
            this.model +
                '/' +
                consorcioId +
                '/' +
                this.subcollection +
                '/' +
                id
        );
        return this.crudService.findFirst<any>('');
    }

    delete(consorcioId: string, id: string) {
        const path =
            this.model + '/' + consorcioId + '/' + this.subcollection + '/' + id;
        this.crudService.setModel(path);
        return this.crudService.delete('');
    }

    async countQuestions(consorcioId: string): Promise<number> {
         const path =
            this.model + '/' + consorcioId + '/' + this.subcollection;
        this.crudService.setModel(path);
        const questions = await this.crudService.countCollection();
        return questions;
    }
    searchByStatus(adminId: string, status:string) {
             const path =this.subcollection;
        this.crudService.setModel(path);
        const filter:any =[
            {
                field: 'status',
                operator: '==',
                value: status,
            },
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]

        return this.crudService.searchCollectionGroupMany<any>(filter, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }
    searchByStatusAndType(adminId: string, status:string,type:TypeQuestion) {
             const path =this.subcollection;
        this.crudService.setModel(path);
        const filter:any =[
            {
                field: 'status',
                operator: '==',
                value: status,
            },
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            },
            {
                field: 'type',
                operator: '==',
                value: type,
            }
        ]

        return this.crudService.searchCollectionGroupMany<any>(filter, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }

    searchMultipleByStatus(adminId: string, status:string[],type?: TypeQuestion) {
             const path =this.subcollection;
        this.crudService.setModel(path);
        const filter:any =[
            {
                field: 'status',
                operator: 'in',
                value: status,
            },
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]
        if(type){
            filter.push({
                field: 'type',
                operator: '==',
                value: type,
            })
        }

        return this.crudService.searchCollectionGroupMany<any>(filter, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }
    searchMultipleByStatusAndType(adminId: string, status:string[],type:TypeQuestion) {
             const path =this.subcollection;
        this.crudService.setModel(path);
        const filter:any =[
            {
                field: 'status',
                operator: 'in',
                value: status,
            },
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            },
            {
                field: 'type',
                operator: '==',
                value: type,
            }
        ]

        return this.crudService.searchCollectionGroupMany<any>(filter, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }

    filter(adminId: string, search:{status: string,consorcioName: string, dateFrom: Date, dateTo: Date,type?: TypeQuestion,notType?: TypeQuestion}) {
        
        const path =this.subcollection;
        this.crudService.setModel(path);
            
            const filter:any =[
            {
                field: 'consorcioName',
                operator: '>=',
                value: search.consorcioName,
            },
            {
                field: 'consorcioName',
                operator: '<=',
                value: search.consorcioName + '\uf8ff',
            },
            
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]

               

        if(search.dateFrom){
            filter.push({
                field: 'createdAt',
                operator: '>=',
                value: search.dateFrom,
            })
        }

        if(search.dateTo){
            filter.push({
                field: 'createdAt',
                operator: '<=',
                value: search.dateTo,
            })
        }

        if(search.status){
            filter.push( {
                field: 'status',
                operator: '==',
                value: search.status,
            });
        }
        if(search.type){
            filter.push({
                field: 'type',
                operator: '==',
                value: search.type,
            });
        }
        if(search.notType){
            filter.push({
                field: 'type',
                operator: '!=',
                value: search.notType,
            });
        }

        return this.crudService.searchCollectionGroupMany<any>(filter,[{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }
     searchMultipleByStatusAndDate(filters:{adminId: string,dateFrom?: any,closedFrom?: any,closedBy?: 'agent' | 'human', status?:string[],type?: TypeQuestion,notType?: TypeQuestion}) {
        const path =this.subcollection;
        this.crudService.setModel(path);

        const query: any[] = [
           {field: 'administrationUserId',
             operator: '==',
             value: filters.adminId
            }
        ];

        if(filters.dateFrom){
           const dateFromTs = Timestamp.fromDate(filters.dateFrom);
            query.push({
                field: 'createdAt',
                operator: '>=',
                value: dateFromTs,
            });
        }

        if(filters.closedFrom){
              const closedFromTs =Timestamp.fromDate(filters.closedFrom);
            query.push({
                field: 'closedAt',
                operator: '>=',
                value: closedFromTs,
            });
        }
        
        if(filters.closedBy){
            query.push({
                field: 'closedBy',
                operator: '==',
                value: filters.closedBy,
            });
        }

        if(filters.status){
            query.push({
                field: 'status',
                operator: 'in',
                value: filters.status,
            });
        }
        if(filters.type){
            query.push({
                field: 'type',
                operator: '==',
                value: filters.type,
            });
        }
        if(filters.notType){
            query.push({
                field: 'type',
                operator: '!=',
                value: filters.notType,
            });
        }


        
       return this.crudService.searchCollectionGroupMany<any>(query, [{
                orderBy: 'createdAt',
                orderByDirection: 'desc',
            },
            {
                orderBy: 'status',
                orderByDirection: 'asc',
            },
        
        ]);
    }
}
